import React from "react"
import styles from "./ErrorPage.module.scss"

interface ErrorPageProps {
    title?: string
    message?: string
}

const ErrorPageComponent: React.FC<ErrorPageProps> = ({
    title = "Oops!",
    message = "Something went wrong. Please try again or return to the homepage."
}) => {
    return (
        <div className={styles.page}>
            <div className={styles.card}>
                <h1 className={styles.title}>{title}</h1>
                <p className={styles.message}>{message}</p>

                <a href="/" className={styles.button}>
                    Go back home
                </a>
            </div>
        </div>
    )
}

export default ErrorPageComponent
